/** Klient for AI-assistenten (/api/assistant). Samtaler og meldinger lagres i backend; svar strømmes som SSE. */
import { apiDelete, apiGet, apiPatch, apiPost, apiStream } from './api';

export const listSessions = () => apiGet('/assistant/sessions');
export const createSession = (title) => apiPost('/assistant/sessions', title ? { title } : {});
export const renameSession = (id, title) => apiPatch(`/assistant/sessions/${id}`, { title });
export const deleteSession = (id) => apiDelete(`/assistant/sessions/${id}`);
export const listMessages = (id) => apiGet(`/assistant/sessions/${id}/messages`);

/**
 * Sender en melding og strømmer svaret.
 * onStart({ messageId, userMessageId }), onDelta(text, { error }), onDone({ messageId }).
 * Kast AbortError via `signal` for å stoppe – delteksten beholdes av kalleren.
 */
export function streamReply(sessionId, { content, context }, { onStart, onDelta, onDone, signal }) {
  return apiStream(`/assistant/sessions/${sessionId}/messages`, { content, context }, {
    signal,
    onEvent: ({ event, data }) => {
      if (event === 'start') onStart?.(data);
      else if (event === 'done') onDone?.(data);
      else if (data && typeof data === 'object' && typeof data.delta === 'string') onDelta?.(data.delta, { error: data.error === true });
    },
  });
}

/** Grupperer samtaler etter dato (Oslo-tid) til samtalelisten. */
export function groupSessions(sessions, now = new Date()) {
  const dayKey = (d) => new Intl.DateTimeFormat('nb-NO', { timeZone: 'Europe/Oslo', year: 'numeric', month: '2-digit', day: '2-digit' }).format(d);
  const today = dayKey(now);
  const yesterday = dayKey(new Date(now.getTime() - 86400000));
  const weekAgo = now.getTime() - 7 * 86400000;
  const groups = [
    { id: 'today', label: 'I dag', items: [] },
    { id: 'yesterday', label: 'I går', items: [] },
    { id: 'week', label: 'Siste 7 dager', items: [] },
    { id: 'older', label: 'Tidligere', items: [] },
  ];
  for (const s of sessions) {
    const d = new Date(s.updatedAt ?? s.createdAt);
    const k = dayKey(d);
    if (k === today) groups[0].items.push(s);
    else if (k === yesterday) groups[1].items.push(s);
    else if (d.getTime() >= weekAgo) groups[2].items.push(s);
    else groups[3].items.push(s);
  }
  return groups.filter((g) => g.items.length);
}
